import { generateTable, initAnnotations } from "../../../ui/table/Utils.js";
import { openColorPicker, openLabelSelection } from "../../layer/GeoJSONLayer.js";

const excludedAnnotations = ["Geodesic Area", "Distance", "Coordinates", "North West", "South East", "Color", "Label"]

/**
 * Exported function to register the template
 * 
 * @param {PopupRenderer} renderer static PopupRenderer class
 * 
 * @memberof vef.map.popup.templates
 */
export function geoJSONLayer(renderer) {

    const template = (content, response, layer, style) => {
        if (!content.features) content = { features: [content] };

        const responses = [];
        for (let i = 0; i < content.features.length; i++) {
            const properties = content.features[i].properties;

            if (!("Label" in properties)) properties.Label = null;

            let html = generateTable(properties, {}, true);
            if (style != "sidebar") {
                initAnnotations(html, properties, excludedAnnotations);

                // handling of color picker
                const colorRow = html.querySelector("tr>td:first-child[title='Color']").parentElement;
                const colorValueCell = colorRow.querySelector("td:last-child");
                colorRow.addEventListener("click", e => {
                    if (e.target.nodeName.toLowerCase() == "a") return;
                    openColorPicker(color => {
                        layer.setColor(content.features[i], color);
                        colorValueCell.innerText = color;
                        colorValueCell.title = color;
                    });
                });

                // handling label selection
                const labelRow = html.querySelector("tr>td:first-child[title='Label']").parentElement;
                const labelValueCell = labelRow.querySelector("td:last-child");
                if (properties.Label == null) {
                    labelValueCell.innerHTML = "<i>not specified</i>";
                    labelValueCell.title = "not specified";
                }
                labelRow.addEventListener("click", e => {
                    if (e.target.nodeName.toLowerCase() == "a") return;
                    openLabelSelection(properties.Label, label => {
                        layer.setLabel(content.features[i], label);
                        if (label == null) {
                            labelValueCell.innerHTML = "<i>not specified</i>";
                        } else {
                            labelValueCell.innerText = label;
                        }
                        labelValueCell.title = labelValueCell.innerText;
                    });
                })

            }

            if (html) responses.push({
                response: response,
                feature: content.features[i],
                layer: layer,
                title: layer.title,
                html: html
            });
        }

        return responses;
    };

    renderer.registerTemplate('geojson_layer', template);
}